import type { GolfCourse } from '@/types/golf';
import { api } from '@/utils/api';
// Define the Course interface here to avoid circular dependencies
export interface Course {
  id: number;
  name: string;
  city: string;
  country: string;
  state?: string;
  slug: string;
  distance: number;
  latlon: {
    x: number;
    y: number;
  } | null;
  thumbnail: string;
  courses?: GolfCourse[];
}

/**
 * Add a golf club to favorites
 * @param clubId The ID of the golf club to add to favorites
 * @returns Promise with the response data
 */
const addFavoriteGolfClub = async (clubId: number): Promise<any> => {
  try {
    const { data } = await api.post('/favorites/golf-clubs', { clubId });
    return data;
  } catch (error) {
    console.error('Error adding favorite club:', error);
    throw error;
  }
};

/**
 * Remove a golf club from favorites
 * @param clubId The ID of the golf club to remove from favorites
 * @returns Promise with the response data
 */
const removeFavoriteGolfClub = async (clubId: number): Promise<any> => {
  try {
    const { data } = await api.delete(`/favorites/golf-clubs/${clubId}`);
    return data;
  } catch (error) {
    console.error('Error removing favorite club:', error);
    throw error;
  }
};

/**
 * Check if a golf club is in favorites
 * @param clubId The ID of the golf club to check
 * @returns Promise with boolean indicating if club is favorited
 */
const isGolfClubFavorited = async (clubId: number): Promise<boolean> => {
  try {
    const { data } = await api.get(`/favorites/golf-clubs/${clubId}/status`);
    return !!data?.isFavorite;
  } catch (error) {
    console.error('Error checking if club is favorited:', error);
    return false;
  }
};

/**
 * Get all favorite golf clubs
 * @returns Promise with array of favorite golf clubs
 */
export const getFavoriteGolfClubs = async (): Promise<Course[]> => {
  try {
    const { data } = await api.get('/favorites-clubs');
    return data || [];
  } catch (error) {
    console.error('Error getting favorite clubs:', error);
    return [];
  }
};
